import { useState } from "react";
import { post } from "../networking/RequestService";

const useGetWonDealsByAccountId = () => {
    const [wonDeals, setWonDeals] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchWonDealsByAccountId = async (id) => {
        if (!id) return;

        setLoading(true);
        setError(null);
        try {
            const res = await post({
                fn: "getWonDealsByAccountId",
                accountId: id,
            });
            setWonDeals(res.data || []);
            return res.data || [];
        } catch (err) {
            setError(err);
            setWonDeals([]);
            return [];
        } finally {
            setLoading(false);
        }
    };

    return { wonDeals, loading, error, fetchWonDealsByAccountId };
};

export default useGetWonDealsByAccountId;
